import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import api from "../../../API/axiosInstance";
import "./../../../styles/datacards.css";
import { generateHash } from "../../../API/hashUtil";
const CardsModal = ({ cardData, open, handleClose }) => {
  const [transData, setTransdata] = useState("");
  // Replace the single state with two separate states
  const [showFullContent, setShowFullContent] = useState(false);
  const [showFullTranslation, setShowFullTranslation] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const token = localStorage.getItem("Token");

  const videoLink = cardData?.link;
  const isValidUrl = (url) => {
    if (!url) return false; // null, undefined, empty
    const badValues = ["n/a", "na", "not available"];
    return !badValues.includes(String(url).trim().toLowerCase());
  };
  if (!cardData) return null;

  // Check if hashtags and all_labels properties exist and are arrays
  const flattenedHashtags = Array.isArray(cardData.hashtags)
    ? cardData.hashtags.flat()
    : [];
  const flattenedLabels = Array.isArray(cardData.all_labels)
    ? cardData.all_labels.flat()
    : [];
  // Updated layout styles - remove fixed height and allow dynamic sizing
  // Updated layout styles - remove fixed height and allow dynamic sizing
  const layoutStyles = {
    container: {
      display: "flex",
      height: "100%", // Take full available height from dialog content
    },
    leftPanel: {
      flex: isValidUrl(cardData.screenshotUrl) || showVideo ? "0 0 50%" : "1",
      padding: "24px",
      overflowY: "auto", // Only scrollbar here
      borderRight:
        isValidUrl(cardData.screenshotUrl) || (showVideo && embedUrl)
          ? "1px solid #f0f0f0"
          : "none",
      height: "100%", // Take full container height
      boxSizing: "border-box",
    },
    rightPanel: {
      flex: "0 0 50%",
      display: "flex",
      flexDirection: "column",
      height: "100%", // Take full container height
      backgroundColor: "#f9fafb",
    },
    mediaContainer: {
      height: "600px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      backgroundColor: "#000",
    },
    transcriptionContainer: {
      flex: 1,
      padding: "20px",
      overflowY: "auto",
      backgroundColor: "#ffffff",
      borderTop: "1px solid #f0f0f0",
    },
    screenshotImage: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      backgroundColor: "#ffff",
      padding: "20px",
    },
    videoIframe: {
      width: "100%",
      height: "100%",
      border: "none",
    },
  };

  // Updated content styles - fix the value style
  const contentStyles = {
    section: {
      marginBottom: "20px",
      padding: "16px",
      backgroundColor: "#f9fafb",
      borderRadius: "8px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      border: "1px solid #e3e6ec",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#111827",
      marginBottom: "10px",
      display: "flex",
      alignItems: "center",
    },
    label: {
      fontSize: "17px",
      fontWeight: 600,
      color: "rgb(44, 78, 128)",
      marginBottom: "6px",
      display: "block",
    },
    value: {
      fontSize: "14px",
      color: "#111827",
      lineHeight: 1.6,
      wordBreak: "break-word",
      // Remove the conflicting display properties and webkit styles
      // These were causing the overflow issues
      // maxHeight: showFullContent ? "none" : "100px", // Remove this from here
      // overflow: showFullContent ? "visible" : "hidden", // Remove this from here
      // textOverflow: "ellipsis", // Remove this
      // WebkitLineClamp: 4, // Remove this
      // WebkitBoxOrient: "vertical", // Remove this
      // display: "-webkit-box", // Remove this
    },
    link: {
      color: "#6366f1",
      textDecoration: "none",
      fontSize: "14px",
    },
    readMoreButton: {
      cursor: "pointer",
      color: "#6366f1",
      fontSize: "14px",
      fontWeight: 500,
      marginTop: "8px",
      display: "inline-block",
    },
    list: {
      listStyleType: "none",
      padding: "0",
      margin: "10px 0",
    },
    listItem: {
      padding: "6px 10px",
      borderRadius: "4px",
      backgroundColor: "#E5D4FF",
      marginBottom: "6px",
      fontSize: "14px",
      display: "inline-block",
      marginRight: "6px",
    },
    contentBlock: {
      backgroundColor: "#f9fafb",
      padding: "12px",
      borderRadius: "8px",
      borderLeft: "3px solid #6366f1",
      marginBottom: "20px",
      borderRight: "1px solid #e3e6ec",
      borderTop: "1px solid #e3e6ec",
      borderBottom: "1px solid #e3e6ec",
    },
    badge: {
      display: "inline-block",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: 500,
      textTransform: "capitalize",
    },
  };

  // Updated modal styles - allow more flexible height
  const modalStyles = {
    dialog: {
      borderRadius: "12px",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    },
    paper: {
      width: "100%",
      maxWidth: "1200px",
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: "#ffffff",
      fontFamily: "'Inter', 'Host Grotesk', sans-serif",
      maxHeight: "95vh", // Allow modal to grow but not exceed viewport
    },
    dialogTitle: {
      padding: "20px 24px",
      borderBottom: "1px solid #f0f0f0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 600,
      fontSize: "18px",
      backgroundColor: "#ffffff",
      color: "#111827",
    },
    dialogContent: {
      padding: "0",
      backgroundColor: "#ffffff",
      // Remove any height restrictions here
    },
    dialogActions: {
      padding: "16px 24px",
      borderTop: "1px solid #f0f0f0",
      backgroundColor: "#ffffff",
    },
    videoToggleButton: {
      backgroundColor: "#6366f1",
      color: "white",
      padding: "8px 16px",
      borderRadius: "8px",
      textTransform: "none",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.08)",
      fontSize: "14px",
      fontWeight: 500,
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.2s",
      fontFamily: "'Host Grotesk', sans-serif",
    },
    closeButton: {
      backgroundColor: "#f3f4f6",
      color: "#111827",
      padding: "8px 24px",
      borderRadius: "8px",
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 500,
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.2s",
      fontFamily: "'Host Grotesk', sans-serif",
    },
  };

  // Utility functions
  // Create separate toggle functions
  const handleToggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  const handleToggleTranslation = () => {
    setShowFullTranslation(!showFullTranslation);
  };

  const getYouTubeEmbedUrl = (url) => {
    if (!url) {
      return null;
    }
    const regex =
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?v=|shorts\/)([^&\n]+)/;
    const match = url.match(regex);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const embedUrl = getYouTubeEmbedUrl(cardData.link);

  const handleToggleVideo = () => {
    setShowVideo(!showVideo);
    handleTrans();
  };

  const handleTrans = () => {
    if (!videoLink) return;

    let stringParams = {
      link: videoLink,
    };
    const HPPcode = generateHash(stringParams);
    api
      .get(`/api/viewcontent`, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
        params: {
          link: videoLink,
          HPPcode: HPPcode,
        },
      })
      .then((transresponse) => {
        setTransdata(transresponse.data);
      })
      .catch((error) => {
        console.error("Error fetching Transcription");
        setTransdata([]);
      });
  };

  // Helper for rendering badge colors based on sentiment/severity
  const getBadgeColor = (type, value) => {
    if (type === "sentiment") {
      switch (value?.toLowerCase()) {
        case "positive":
          return { background: "#dcfce7", color: "#166534" };
        case "negative":
          return { background: "#fee2e2", color: "#b91c1c" };
        case "neutral":
          return { background: "#e0f2fe", color: "#0369a1" };
        default:
          return { background: "#f3f4f6", color: "#4b5563" };
      }
    } else if (type === "severity") {
      switch (value?.toLowerCase()) {
        case "high":
          return { background: "#fee2e2", color: "#b91c1c" };
        case "medium":
          return { background: "#fef3c7", color: "#92400e" };
        case "low":
          return { background: "#dcfce7", color: "#166534" };
        default:
          return { background: "#f3f4f6", color: "#4b5563" };
      }
    }
    return { background: "#f3f4f6", color: "#4b5563" };
  };
  // Add these utility functions at the top of your component
  const isTextOverflowing = (text, maxHeight = 100) => {
    // Create a temporary element to measure text height
    const tempElement = document.createElement("div");
    tempElement.style.position = "absolute";
    tempElement.style.visibility = "hidden";
    tempElement.style.height = "auto";
    tempElement.style.width = "100%";
    tempElement.style.fontSize = "14px";
    tempElement.style.lineHeight = "1.5";
    tempElement.style.wordWrap = "break-word";
    tempElement.innerHTML = text;

    document.body.appendChild(tempElement);
    const actualHeight = tempElement.scrollHeight;
    document.body.removeChild(tempElement);

    return actualHeight > maxHeight;
  };

  // Alternative simpler approach - check if text is long enough to potentially overflow
  const isTextLongEnoughToOverflow = (text) => {
    return text && text.length > 300; // Adjust this threshold as needed
  };

  const lowercaseRomanNumerals = (text) => {
    return text
      .replace(/\((?=[IVXLCDM]+\))/g, "(")
      .replace(/\b[IVXLCDM]+\b/g, (match) => match.toLowerCase());
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      maxWidth={false}
      PaperProps={{
        style: modalStyles.paper,
        size: "xl",
      }}
      fullWidth
    >
      <DialogTitle style={modalStyles.dialogTitle}>
        <div
          style={{
            fontFamily: "'Host Grotesk', sans-serif",
            color: "#2c4e80",
            fontSize: "25px",
          }}
        >
          Post Details
        </div>
        {embedUrl && (
          <Button
            onClick={handleToggleVideo}
            style={modalStyles.videoToggleButton}
          >
            {showVideo ? "View Screenshot" : "Watch Video"}
          </Button>
        )}
      </DialogTitle>

      <DialogContent style={modalStyles.dialogContent} dividers>
        <div style={layoutStyles.container}>
          {/* Left Panel - Post Information */}
          <div style={layoutStyles.leftPanel}>
            {/* User & Platform Info */}
            <div style={contentStyles.section}>
              <h3 style={contentStyles.sectionTitle}>
                <span
                  style={{
                    width: "20px",
                    height: "20px",
                    display: "inline-block",
                    backgroundColor: "#6366f1",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></span>
                Post Information
              </h3>

              {cardData.postOwner && (
                <div style={{ marginBottom: "12px" }}>
                  <div style={contentStyles.label}>User Name</div>
                  <a
                    href={cardData.useHandle}
                    style={contentStyles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {cardData.postOwner}
                  </a>
                </div>
              )}

              {cardData.platform && (
                <div style={{ marginBottom: "12px" }}>
                  <div style={contentStyles.label}>Platform</div>
                  <span>
                    {cardData.platform.charAt(0).toUpperCase() +
                      cardData.platform.slice(1).toLowerCase() || "N/A"}
                  </span>
                </div>
              )}

              {cardData.datetime && (
                <div style={{ marginBottom: "12px" }}>
                  <div style={contentStyles.label}>Date & Time</div>
                  <span>
                    {new Intl.DateTimeFormat("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "2-digit",
                      timeZone: "UTC", // avoids local timezone conversion
                    }).format(new Date(cardData.datetime))}
                    , 
                    {new Intl.DateTimeFormat("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                      timeZone: "UTC", // avoids local timezone conversion
                    }).format(new Date(cardData.datetime))}
                  </span>
                </div>
              )}
            </div>
            {cardData.platform === "YOUTUBE" ? (
              <>
                {/* Title block */}
                {cardData.title && cardData.title.length > 0 && (
                  <div style={contentStyles.contentBlock}>
                    <div
                      style={{
                        display: "inline-block",
                        backgroundColor: "#e3f2fd",
                        color: "#1976d2",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "8px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      Title
                    </div>
                    <div
                      style={{
                        ...contentStyles.value,
                        maxHeight: showFullContent ? "none" : "95px",
                        overflow: showFullContent ? "visible" : "hidden",
                      }}
                    >
                      {cardData.title}
                    </div>
                    {isTextLongEnoughToOverflow(cardData.title) && (
                      <span
                        style={contentStyles.readMoreButton}
                        onClick={handleToggleContent}
                      >
                        {showFullContent ? "Read Less" : "Read More"}
                      </span>
                    )}
                  </div>
                )}

                {/* Title Translation block */}
                {cardData.titleTranslation &&
                  cardData.titleTranslation.length > 0 && (
                    <div style={contentStyles.contentBlock}>
                      <div
                        style={{
                          display: "inline-block",
                          backgroundColor: "#f3e5f5",
                          color: "#7b1fa2",
                          padding: "4px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "500",
                          marginBottom: "8px",
                          border: "1px solid #e1bee7",
                        }}
                      >
                        Title Translation
                      </div>
                      <div
                        style={{
                          ...contentStyles.value,
                          maxHeight: showFullTranslation ? "none" : "95px",
                          overflow: showFullTranslation ? "visible" : "hidden",
                          marginBottom: "20px",
                        }}
                      >
                        {cardData.titleTranslation}
                      </div>
                      {isTextLongEnoughToOverflow(
                        cardData.titleTranslation
                      ) && (
                        <span
                          style={contentStyles.readMoreButton}
                          onClick={handleToggleTranslation}
                        >
                          {showFullTranslation ? "Read Less" : "Read More"}
                        </span>
                      )}
                    </div>
                  )}
              </>
            ) : (
              <>
                {/* Content block */}
                {cardData.content && cardData.content.length > 0 && (
                  <div style={contentStyles.contentBlock}>
                    <div
                      style={{
                        display: "inline-block",
                        backgroundColor: "#e3f2fd",
                        color: "#1976d2",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "8px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      Original
                    </div>
                    <div
                      style={{
                        ...contentStyles.value,
                        maxHeight: showFullContent ? "none" : "95px",
                        overflow: showFullContent ? "visible" : "hidden",
                      }}
                    >
                      {cardData.content}
                    </div>
                    {isTextLongEnoughToOverflow(cardData.content) && (
                      <span
                        style={contentStyles.readMoreButton}
                        onClick={handleToggleContent}
                      >
                        {showFullContent ? "Read Less" : "Read More"}
                      </span>
                    )}
                  </div>
                )}

                {/* Translation block */}
                {cardData.translation && cardData.translation.length > 0 && (
                  <div style={contentStyles.contentBlock}>
                    <div
                      style={{
                        display: "inline-block",
                        backgroundColor: "#f3e5f5",
                        color: "#7b1fa2",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "8px",
                        border: "1px solid #e1bee7",
                      }}
                    >
                      Translation
                    </div>
                    <div
                      style={{
                        ...contentStyles.value,
                        maxHeight: showFullTranslation ? "none" : "95px",
                        overflow: showFullTranslation ? "visible" : "hidden",
                        marginBottom: "20px",
                      }}
                    >
                      {cardData.translation}
                    </div>
                    {isTextLongEnoughToOverflow(cardData.translation) && (
                      <span
                        style={contentStyles.readMoreButton}
                        onClick={handleToggleTranslation}
                      >
                        {showFullTranslation ? "Read Less" : "Read More"}
                      </span>
                    )}
                  </div>
                )}
              </>
            )}

            {/* Metadata Section */}
            <div style={contentStyles.section}>
              <h3 style={contentStyles.sectionTitle}>
                <span
                  style={{
                    width: "20px",
                    height: "20px",
                    display: "inline-block",
                    backgroundColor: "#6366f1",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></span>
                Metadata
              </h3>

              <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                {/* Left column */}
                <div style={{ flex: "1 1 45%" }}>
                  {cardData.languages && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Language</div>
                      <span>{cardData.languages}</span>
                    </div>
                  )}

                  {cardData.keyword && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Keyword</div>
                      <span>{cardData.keyword}</span>
                    </div>
                  )}

                  {cardData.language_type && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Language Type</div>
                      <span>{cardData.language_type}</span>
                    </div>
                  )}

                  {cardData.link && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Link</div>
                      <a
                        href={cardData.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={contentStyles.link}
                      >
                        View Source
                      </a>
                    </div>
                  )}
                </div>

                {/* Right column */}
                <div style={{ flex: "1 1 45%" }}>
                  {cardData.sentiment && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Sentiment</div>
                      <span
                        style={{
                          ...contentStyles.badge,
                          ...getBadgeColor("sentiment", cardData.sentiment),
                        }}
                      >
                        {cardData.sentiment}
                      </span>
                    </div>
                  )}

                  {cardData.severity_level && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Severity Level</div>
                      <span
                        style={{
                          ...contentStyles.badge,
                          ...getBadgeColor("severity", cardData.severity_level),
                        }}
                      >
                        {cardData.severity_level}
                      </span>
                    </div>
                  )}

                  {cardData.legality && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Legality</div>
                      <span>{cardData.legality}</span>
                    </div>
                  )}

                  {cardData.intensity && (
                    <div style={{ marginBottom: "12px" }}>
                      <div style={contentStyles.label}>Legal Intensity</div>
                      <span>{cardData.intensity}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Hashtags and Sections */}
            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
              {/* Sections */}
              {cardData.sections && cardData.sections.length > 0 && (
                <div style={{ ...contentStyles.section, flex: "1 1 45%" }}>
                  <h3 style={contentStyles.sectionTitle}>
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        display: "inline-block",
                        backgroundColor: "#6366f1",
                        borderRadius: "50%",
                        marginRight: "8px",
                      }}
                    ></span>
                    Sections Violated
                  </h3>
                  <ul style={contentStyles.list}>
                    {cardData.sections.map((section, index) => (
                      <li key={index} style={contentStyles.listItem}>
                        {lowercaseRomanNumerals(section)}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Hashtags */}
              {Array.isArray(cardData.hashtags) &&
                cardData.hashtags.length > 0 && (
                  <div style={{ ...contentStyles.section, flex: "1 1 45%" }}>
                    <h3 style={contentStyles.sectionTitle}>
                      <span
                        style={{
                          width: "20px",
                          height: "20px",
                          display: "inline-block",
                          backgroundColor: "#6366f1",
                          borderRadius: "50%",
                          marginRight: "8px",
                        }}
                      ></span>
                      Hashtags
                    </h3>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
                    >
                      {cardData.hashtags.map((hashtag, index) => (
                        <span
                          key={index}
                          style={{
                            padding: "4px 10px",
                            borderRadius: "16px",
                            backgroundColor: "#e0e7ff",
                            color: "#4f46e5",
                            fontSize: "12px",
                            fontWeight: 500,
                            margin: "2px",
                          }}
                        >
                          {hashtag.trim()}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </div>

          {/* Right Panel - Media Content */}
          {(isValidUrl(cardData.screenshotUrl) || (showVideo && embedUrl)) && (
            <div style={layoutStyles.rightPanel}>
              {showVideo && embedUrl ? (
                <>
                  <div style={layoutStyles.mediaContainer}>
                    <iframe
                      src={embedUrl}
                      title="YouTube Video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={layoutStyles.videoIframe}
                    ></iframe>
                  </div>
                  <div style={layoutStyles.transcriptionContainer}>
                    <h3
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        marginBottom: "12px",
                        color: "#111827",
                      }}
                    >
                      Video Transcription
                    </h3>
                    {transData.length > 0 &&
                    transData[0].content &&
                    transData[0].content[2] &&
                    transData[0].content[2].translation !== "none" ? (
                      <div style={contentStyles.contentBlock}>
                        {transData[0].content[2].translation}
                      </div>
                    ) : (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#6b7280",
                          backgroundColor: "#f3f4f6",
                          borderRadius: "8px",
                        }}
                      >
                        No transcription available
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div
                  style={{
                    ...layoutStyles.mediaContainer,
                    height: "100%",
                    backgroundColor: "#f3f4f6",
                  }}
                >
                  <img
                    src={cardData.screenshotUrl}
                    alt="Screenshot"
                    style={layoutStyles.screenshotImage}
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                      e.target.style.display = "none";
                      // Or show a placeholder
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </DialogContent>

      <DialogActions style={modalStyles.dialogActions}>
        <Button onClick={handleClose} style={modalStyles.closeButton}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CardsModal;
